import {
  DebitCardColour,
  DebitCardFormat,
  MoneyInput,
  VelocityWindowEnum,
} from 'types/gql-global-types'

export enum ReportLostAndReplaceCardStage {
  ReportLostCard = 'ReportLostCard',
  ReportLostPhysicalCardError = 'ReportLostPhysicalCardError',
  ReportLostVirtualCardError = 'ReportLostVirtualCardError',
  ReplaceCardAddress = 'ReplaceCardAddress',
  ReplaceCardErrorAdmin = 'ReplaceCardErrorAdmin',
  ReplaceCardErrorManager = 'ReplaceCardErrorManager',
}

export enum AddressPage {
  PredefinedAddress = 'PredefinedAddress',
  CustomAddress = 'CustomAddress',
}

export interface Address {
  street1: string | null
  street2: string | null
  suburb: string | null
  state: string | null
  postcode: string | null
  country: string | null
}

export type VelocityControl = {
  amountLimit: MoneyInput
  maxTransactionValue: MoneyInput
  timeZone?: string
  velocityWindow: VelocityWindowEnum
}

export interface ReportLostCardState {
  stage: ReportLostAndReplaceCardStage.ReportLostCard
  cardId: string
  isAdmin: boolean
  cardColor: DebitCardColour
  cardFormat: DebitCardFormat
  isCardOwner: boolean
  cardOwnerFirstName: string | null | undefined
  velocityControl: VelocityControl | null
  entityAddressTimezone: any
}

export interface ReplaceCardAddressState {
  stage: ReportLostAndReplaceCardStage.ReplaceCardAddress
  cardId: string
  isAdmin: boolean
  cardColor: DebitCardColour
  cardFormat: DebitCardFormat
  velocityControl: VelocityControl | null
  entityAddressTimezone: any
  address?: Address
}

export interface ReportLostPhysicalCardErrorState {
  stage: ReportLostAndReplaceCardStage.ReportLostPhysicalCardError
  cardId: string
  isAdmin: boolean
  cardColor: DebitCardColour
  address: Address
  velocityControl: VelocityControl | null
  entityAddressTimezone: any
}

export interface ReportLostVirtualCardErrorState {
  stage: ReportLostAndReplaceCardStage.ReportLostVirtualCardError
  cardId: string
  isAdmin: boolean
  cardColor: DebitCardColour
  isCardOwner: boolean
  cardOwnerFirstName: string | null | undefined
  velocityControl: VelocityControl | null
  entityAddressTimezone: any
}

export interface ReplaceCardErrorAdminState {
  stage: ReportLostAndReplaceCardStage.ReplaceCardErrorAdmin
  velocityControl: VelocityControl | null
  entityAddressTimezone: any
}

export interface ReplaceCardErrorManagerState {
  stage: ReportLostAndReplaceCardStage.ReplaceCardErrorManager
  velocityControl: VelocityControl | null
  entityAddressTimezone: any
}

export type ReportLostAndReplaceCardErrorState =
  | ReportLostPhysicalCardErrorState
  | ReportLostVirtualCardErrorState
  | ReplaceCardErrorAdminState
  | ReplaceCardErrorManagerState

export type ReportLostAndReplaceCardState =
  | ReportLostCardState
  | ReplaceCardAddressState
  | ReportLostAndReplaceCardErrorState
